import React from "react";
import LocationPage from "./LocationPage";

export default function WebdesignAgenturOesterreich() {
  return <LocationPage locationKey="oesterreich" />;
}
